import { excuseApi } from "../commons/http";

class User {
  constructor(data = {}) {
    this.id = data.id;
    this.name = data.name;
    this.address = data.address;
    this.phone_number = data.phone_number;
    this.backup_phone_number = data.backup_phone_number;
    this.note = data.note;
    this.email = data.email;
    this.referral_source = data.referral_source;
    this.tags = data.tags;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.last_order_date = data.last_order_date;
    this.menu_status = data.menu_status;
    this.active_menu_id = data.active_menu_id;
    this.active_menu_title = data.active_menu_title;
    this.menu_last_delivery_date = data.menu_last_delivery_date;
  }

  mapData(data) {
    this.id = data.id;
    this.name = data.name;
    this.address = data.address;
    this.phone_number = data.phone_number;
    this.backup_phone_number = data.backup_phone_number;
    this.note = data.note;
    this.email = data.email;
    this.referral_source = data.referral_source;
    this.tags = data.tags;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.last_order_date = data.last_order_date;
    this.menu_status = data.menu_status;
    this.active_menu_id = data.active_menu_id;
    this.active_menu_title = data.active_menu_title;
    this.menu_last_delivery_date = data.menu_last_delivery_date;
  }

  async getUserById(id) {
    try {
      const res = await excuseApi({
        path: `/users/${id}`,
        method: 'GET',
      })
      if (res.status === 200 || res.status === 201) {
        this.mapData(res.data.data);
        return { data: res.data.data, total: res.data.total };
      }
    }
    catch (error) {
      throw error;
    }
  }

  async save() {
    const res = await excuseApi({
      path: '/users',
      method: 'POST',
      body: {
        name: this.name,
        phone_number: this.phone_number,
        backup_phone_number: this.backup_phone_number,
        address: this.address,
        note: this.note,
        email: this.email,
        referral_source: this.referral_source,
        tags: this.tags,
      }
    });
    if (res.status === 200 || res.status === 201) {
      return { success: true, messenge: "Thêm khách hàng thành công!" }
    }
    else {
      return { success: false, message: "Thêm khách hàng thất bại!, vui lòng liên hệ bộ phận kĩ thuật" };
    }
  }

  async updateUser() {
    try {
      const res = await excuseApi({
        path: `/users/${this.id}`,
        method: 'PUT',
        body: {
          name: this.name,
          address: this.address,
          phone_number: this.phone_number,
          backup_phone_number: this.backup_phone_number,
          note: this.note,
          email: this.email,
          tags: this.tags,
        }
      });
      if (res.status === 200 || res.status === 201) {
        return { success: true, messenge: "Chỉnh sửa thông tin khách hàng!" }
      }
      else {
        return { success: false, message: "Chỉnh sửa thông tin khách hàng thất bại!, vui lòng liên hệ bộ phận kĩ thuật" };
      }
    }
    catch (error) {
      throw error;
    }
  }
}

export default User;
